import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class CheckingAccountResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'current_account': {
                    'customer': {
                        'code': '1234',
                        'fantasy_name': 'Michael',
                        'business_name': 'Dunder Mifflin',
                        'taxpayer_identification_number': '334333322'
                    },
                    'outstanding_balance': {
                        'amount': 0,
                        'currency': 'ARS'
                    }, 'overdue_balance': {
                        'amount': 0,
                        'currency': 'ARS'
                    }, 'unassigned_balance': {
                        'amount': 0,
                        'currency': 'ARS'
                    }, 'total_balance': {
                        'amount': 0,
                        'currency': 'ARS'
                    }
                },
                'accounting_documents': [{
                    'emission_date': '9-12-18',
                    'type': 'A',
                    'point_of_sale': '',
                    'number': '1',
                    'is_debit': 'boolean',
                    'is_credit': 'boolean',
                    'expiration_date': '26-6-11',
                    'total': {
                        'amount': '100',
                        'currency': 'ARS',
                    }
                }]
            },
            errors: []
        }
    }

    currentAccountAndDocuments(){
        return {
            currentAccount: this.current_account(),
            accountingDocuments: this.accounting_documents()
        }
    }

    current_account() {
        const current_account = this.content().current_account
        return {
            fantasyName : current_account.customer.fantasy_name,
            businessName: current_account.customer.business_name,
            outstandingBalanceAmount: current_account.outstanding_balance.amount,
            overdueBalanceAmount: current_account.overdue_balance.amount,
            unassignedBalanceAmount: current_account.unassigned_balance.amount,
            totalBalanceAmount: current_account.total_balance.amount,
        }
    }

    accounting_documents() {
        return this.content().accounting_documents.map(accounting_document => {
            return {
                emissionDate: accounting_document.emission_date,
                type: accounting_document.type,
                pointOfSale: accounting_document.point_of_sale,
                number: accounting_document.number,
                isDebit: accounting_document.is_debit,
                isCredit: accounting_document.is_credit,
                expirationDate: accounting_document.expiration_date,
                total: accounting_document.total.amount,
            }
        })
    }
}